import { OrganizationalUnitsList, PageHeader } from 'src/components';

export function OrganizationalUnitsPage() {
  return (
    <section className="flex flex-col max-w-right-section mx-auto px-6 xl:px-0">
      <PageHeader
        title="Organizational units"
        description="Manage and structure the company’s hierarchy by creating and organizing distinct organizational units"
      />
      <OrganizationalUnitsList />
    </section>
  );
}
